module.exports = __webpack_public_path__ + "static/logo-f75636ae65485bea32d8cff59b699539.png";